import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}notification_organization`;

//  * FIND NOTIFICATION
export function findNotification(queryParams) {
  return axios.post(`${URL}/find`, queryParams);
}
// * CREATE NOTIFICATION
export function createNotification(payload) {
  return axios.post(`${URL}/`, payload);
}
// * UPDATE NOTIFICATION
export function updateNotification(payload) {
  return axios.put(`${URL}/${payload.uuid}`, payload);
}
// * DELETE FOLDER
export function deleteNotificationFolder(id) {
  return axios.delete(`${URL}/delete_folder/${id}`);
}

//  * FIND LIBRARY FILE
export function findnotificationFile(queryParams) {
  return axios.post(`${URL}/find_file`, queryParams);
}
// * UPLOAD FILE
export function createNotificationFile(payload) {
  return axios.post(`${URL}/create_file`, payload);
}
// * DELETE FILE
export function deleteNotificationFile(id) {
  return axios.delete(`${URL}/delete_file/${id}`);
}
